import "../../App.css"
import { HistoryContainer, Sidebar } from "../components"
export const History = () => {
    return (
        <div className='main-container'>
            <Sidebar />
            <HistoryContainer />
        </div>
    )
}
